import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Copy } from 'lucide-react';
import { API } from '../../lib/constants';
import { copyText } from '../../lib/clipboard';

export const OutboxCard = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/outbox`).then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="card" data-testid="outbox-card">
      <div className="px-6 py-4 border-b-2 border-line flex items-center gap-2">
        <Mail className="w-4 h-4 text-cyan" />
        <h3 className="h-display text-sm">Album link requests</h3>
        <span className="badge-warning ml-auto !normal-case !tracking-normal !font-body">Email delivery mocked — copy & send manually</span>
      </div>
      {items.length === 0 ? (
        <p className="px-6 py-8 font-mono text-xs uppercase tracking-[0.2em] text-slate-500 text-center" data-testid="no-outbox">No requests yet</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full table-dark" data-testid="outbox-table">
            <thead><tr>{['When', 'Guest', 'Email', 'Album link', ''].map((h) => <th key={h}>{h}</th>)}</tr></thead>
            <tbody>
              {items.map((m, i) => (
                <tr key={m.created_at + m.to} data-testid={`outbox-row-${i}`}>
                  <td className="text-slate-400">{new Date(m.created_at).toLocaleString()}</td>
                  <td className="font-semibold text-white">{m.recipient_name}</td>
                  <td>{m.to}</td>
                  <td><code className="text-xs text-cyan">/t/…/gallery/{m.gallery_id}</code></td>
                  <td>
                    <button data-testid={`copy-outbox-${i}-btn`} onClick={async () => { (await copyText(m.gallery_url)) && toast.success('Album link copied'); }} className="icon-btn ml-auto" title="Copy link"><Copy className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
